module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "help-us-kiddies"
    }
  }, [_c('h1', [_vm._v("Help Us, Kiddies")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Why not believe in pixies and fairies,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Of course unicorns too?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("They have been here for centuries,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Just search your garden for a clue.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Moonlight, blue it beams down,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("As little elves dance for joy.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("There are even special hidden towns,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("For every believing girl and boy.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Clovers with four leaves,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Will bring you lifelong luck.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("If you find one in amongst the trees,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Carefully pick it up.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Believing though it is a must,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("If you seek these magical scenes!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("I once sneezed on fairy dust,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("They are real, so it seems!")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Invisible to the grumpy mind,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("A whole world of wonder for you awaits!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Deep in moss-covered forests you’ll find,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Smiling creatures in ecstatic states!")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Keep on saying that you believe,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Please don’t make your new friends cry!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("For should you forget they do grieve,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("They grieve until they die.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4788824c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch010.vue
// module id = 90
// module chunks = 0